module.exports = __webpack_public_path__ + "img/search.ee062ddf.svg";